import React, { Fragment } from "react";

const Camas = ({ combinacionesDeCamas = [], onCombinacionDeCamaClick, idProducto, habitacion }) => {
  if (combinacionesDeCamas.length === 0) return <Fragment></Fragment>;

  const handleCombinacionDeCamaClick = (idHabitacion, idCombinacionCama) => {
    onCombinacionDeCamaClick(idProducto, idHabitacion, idCombinacionCama);
  };

  return (
    <section className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 payment clearfix">
          <h4>
            <i
              className="material-icons iconos-pagos"
              title="Combinacion de Camas"
            >
              bed
            </i>{" "}
            elija una disposicion de camas
          </h4>
          <ul className="row">
            {combinacionesDeCamas.map((combinacion, i) => {
                return (
                  <li
                    className="liPuntosDeEmbarque"
                    style={{boxShadow: 'none'}}
                    key={combinacion.idCombinacionCama}
                  >
                    <input
                      className="radioPuntoEmbarque"
                      type="radio"
                      id={combinacion.idCombinacionCama}
                      name={habitacion.idHabitacion}
                      onChange={(e) => handleCombinacionDeCamaClick(habitacion.idHabitacion, combinacion.idCombinacionCama)}
                      value={combinacion.idCombinacionCama}
                      checked={
                        habitacion.idCombinacionCama === combinacion.idCombinacionCama
                      }
                    />
                    <label style={{marginRight: '15px'}}>{combinacion.nombre}</label>
                  </li>
                );
              })}
          </ul>
        </section>
  );
};

export default Camas;



// WEBPACK FOOTER //
// ./src/components/Hoteles/ResultadosCdr/ProductoCuadro/camas.js